import React, { ComponentType, ElementType, LazyExoticComponent } from "react";
import { useParams } from "react-router-dom";
import { CustomObject } from "framework-react-ccs";

type Props = {
    Component:
        | LazyExoticComponent<(props: CustomObject) => JSX.Element>
        | ComponentType
        | ElementType
        | React.FC<CustomObject>;
};

export const PageWrapper = ({ Component }: Props) => {
    const params = useParams();

    return <Component {...params} />;
};
